import React, { ErrorInfo } from 'react'

import { captureError } from 'conversations/utils/logRocket'

interface Props {
  children: React.ReactNode
  errorState: React.ReactNode
}

interface State {
  error?: Error
  hasError: boolean
}

export class ErrorBoundary extends React.Component<Props, State> {
  public constructor(props: Props) {
    super(props)
    this.state = { error: undefined, hasError: false }
  }

  public static getDerivedStateFromError(error: Error) {
    return { error, hasError: true }
  }

  public componentDidCatch(error: Error, info: ErrorInfo) {
    captureError(error, 'Error Boundary Did Catch', { componentStack: info.componentStack })
  }

  public render() {
    if (this.state.hasError) {
      return this.props.errorState
    }

    return this.props.children
  }
}

interface ErrorBoundaryWithHandlerProps {
  onError: (error: Error) => void
}

export class ErrorBoundaryWithHandler extends React.Component<ErrorBoundaryWithHandlerProps> {
  public constructor(props: ErrorBoundaryWithHandlerProps) {
    super(props)
  }

  public componentDidCatch(error: Error) {
    this.props.onError(error)
  }

  public render() {
    return this.props.children
  }
}
